module.exports = __webpack_public_path__ + "static/media/falarpsicologo.0a84021f.jpg";